(function () {
    SUGApp.controller("shareYourStoryController",  ["$scope",'commonRegExService' ,
      function ($scope, commonRegExService) {

        /**
		 * Kicks off page flow tasks
		 * @constructor
		 */
		var initialize = function () {
			// main data objects
			$scope.user = { name: '', email: '', state_city:'', organization_name: '', organization_type : '', message : '', confirmation : '' };
		};

        // Used for submit the form
        $scope.submitForm = function(){
            if(validateForm()){
                var formData = new FormData();
                formData.append("entry.241268794", $scope.user.name);
                formData.append("entry.2118221368", $scope.user.email);
                formData.append("entry.1066028566", $scope.user.state_city);
                formData.append("entry.1764002160", $scope.user.organization_name);
                formData.append("entry.1742916747", $scope.user.organization_type);
                formData.append("entry.865379055", $scope.user.message);

                function successUpdate() {
                    document.getElementsByClassName("form-data")[0].classList.add("hidden");
                    document.getElementsByClassName("beforeresponse")[0].innerText  = 'Thanks for sharing your story!'
                    document.getElementsByClassName("beforeresponse")[0].classList.remove("h2");
                    document.getElementsByClassName("beforeresponse")[0].classList.add("text-center", "afterresponse");
                }

                function failureUpdate() {
                    document.getElementsByClassName("form-data")[0].classList.add("hidden");
                    document.getElementsByClassName("beforeresponse")[0].innerText  = 'Sorry, something went wrong!';
                    document.getElementsByClassName("beforeresponse")[0].classList.add("text-center", "afterresponse");
                    var newParagraph = '<p class="text-center">Please reach out for <a href="/help">help here</a>.</p>';
                    document.getElementsByClassName("beforeresponse")[0].insertAdjacentHTML('afterend', newParagraph);
                }

                fetch('https://docs.google.com/forms/u/0/d/e/1FAIpQLSfnGFk58_Vmnwh3GlTqeD2yg-Mq-_jJ7SFZcOmFQ19yQvh1DQ/formResponse', {
                    method: "POST",
                    body: formData,
                    mode: 'no-cors'
                })
                .then(() => {
                    // Since we're in no-cors mode, we can't check the response status or read the body.
                    // We proceed under the assumption that the request was successful.
                    successUpdate()
                })
                .catch((error) => {
                    // This will catch network errors, but not HTTP errors since they're opaque.
                    console.log('Error', error);
                    failureUpdate()
                });
                
            } else {
                console.error('One or more required fields was missed. Please fill out the fields.')
            }
        }

        // Used for validating the form
        var validateForm = function(){
            let isFormValidate = true;
            if(!$scope.user.name){
                isFormValidate = false
            } else if(!$scope.user.email){
                isFormValidate = false
            }else if(!commonRegExService.emailRegEx().test($scope.user.email)){
                isFormValidate = false
            } else if(!$scope.user.message){
                isFormValidate = false
            } else if(!$scope.user.confirmation){
                isFormValidate = false
            }

            return isFormValidate
        }

        // Initialize the scope data
        initialize();
      },
    ]
    );
  })();
  